import { render } from "./index-base.vue?vue&type=template&id=45f49fcc"
import script from "./index-base.vue?vue&type=script&lang=js"
export * from "./index-base.vue?vue&type=script&lang=js"

import exportComponent from "/home/geangeowle/Workspace/NT-Marketing-Digital/ecolatas/ecolatas-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__